import { ErrorOverlay, LoadingOverlay } from "../GaiaGridOverlay";

interface GaiaLoadingHelperV2Props<TData> {
    data: TData | null | undefined;
    error?: Error | null;
    loading: boolean;
    render: (data: TData) => React.ReactNode;
}

export function GaiaLoadingHelperV2<TData>({ data, error, loading, render }: GaiaLoadingHelperV2Props<TData>) {
    if (loading === true) {
        return <LoadingOverlay />;
    }

    if (data !== undefined && data !== null) {
        return render(data);
    }

    return <ErrorOverlay error={error} />;
}
